"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var redux_1 = require("redux");
/*******************************************************
 * Utils
 *******************************************************/
var makeType = function (prefix, suffix) {
    return "" + prefix + (suffix ? '/' + suffix : '');
};
var ensureArray = function (items) {
    return Array.isArray(items) ? items : [items];
};
var defaultGenerateId = function () {
    return ([1e7].toString() + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^
            (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16);
    });
};
/*******************************************************
 * Constants
 *******************************************************/
var RESET_ALL = 'RESET_ALL_BRANCHES';
exports.createConstant = function (name, constant) {
    return name + "/" + constant;
};
exports.createConstants = function (name) { return ({
    CREATE: exports.createConstant(name, 'CREATE'),
    REPLACE: exports.createConstant(name, 'REPLACE'),
    UPDATE: exports.createConstant(name, 'UPDATE'),
    REMOVE: exports.createConstant(name, 'REMOVE'),
    SET_META: exports.createConstant(name, 'SET_META'),
    RESET: exports.createConstant(name, 'RESET'),
    NOOP: exports.createConstant(name, 'NOOP')
}); };
/** A factory method for creating selector primitives. */
exports.createSelectors = function (_a) {
    var name = _a.name;
    var all = function (
    /** Your store's state object. */
    state) {
        return Object.values(state[name].items);
    };
    return {
        /** Get all items */
        all: all,
        /** Get an item by id */
        byId: function (
        /** Your store's state object. */
        state, _a) {
            var id = _a.id;
            return state[name].items[id || ''];
        },
        /** Get multiple items by their id */
        byIds: function (
        /** Your store's state object. */
        state, _a) {
            var ids = _a.ids;
            return ids.reduce(function (acc, id) {
                if (id) {
                    acc[id] = state[name].items[id || ''];
                }
                return acc;
            }, {});
        },
        /** Gets an object map of unique ids to items {itemId: ItemT} */
        mapById: function (
        /** Your store's state object. */
        state) { return state[name].items; },
        /** Gets an object map of values of an item to an item {itemValueForKey: ItemT[]} */
        mapByKey: function (
        /** Your store's state object. */
        state, _a) {
            var key = _a.key;
            var items = state[name].items;
            return Object.values(items).reduce(function (acc, item) {
                if (!item) {
                    return acc;
                }
                var arr = (acc[item[key]] = acc[item[key]] || []);
                arr.push(item);
                return acc;
            }, {});
        },
        /** Get items that meet a filter condition */
        where: function (
        /** Your store's state object. */
        state, _a) {
            var callback = _a.callback;
            return all(state).filter(callback);
        },
        /** Get the top level meta content  */
        meta: function (
        /** Your store's state object. */
        state) {
            return state[name];
        }
    };
};
/*******************************************************
 * Action Creators
 *******************************************************/
/** An action creator to reset all branches */
exports.resetAllBranches = function () { return ({
    type: RESET_ALL
}); };
/** A factory method for creating action primitives. */
exports.createActions = function (_a) {
    var name = _a.name, _b = _a.defaultItem, defaultItem = _b === void 0 ? {} : _b, _c = _a.generateId, generateId = _c === void 0 ? defaultGenerateId : _c;
    var constant = exports.createConstants(name);
    return {
        /** Create an item */
        create: function (items, typeSuffix) {
            var ensureItem = (items || {});
            var newCreateItems = ensureArray(ensureItem).map(function (item) {
                if (item.id === undefined) {
                    item.id = generateId();
                }
                return __assign(__assign({}, defaultItem), item);
            });
            return {
                type: makeType(constant.CREATE, typeSuffix),
                items: ensureArray(newCreateItems)
            };
        },
        /** Update an item */
        update: function (items, typeSuffix) {
            return {
                type: makeType(constant.UPDATE, typeSuffix),
                items: ensureArray(items)
            };
        },
        /** Remove an item */
        remove: function (items, typeSuffix) {
            var wrappedItems = !Array.isArray(items) ? [items] : items;
            return {
                type: makeType(constant.REMOVE, typeSuffix),
                items: ensureArray(typeof wrappedItems[0] === 'string'
                    ? wrappedItems.map(function (id) { return ({ id: id }); })
                    : wrappedItems)
            };
        },
        /** Replace an item */
        replace: function (items, typeSuffix) {
            return {
                type: makeType(constant.REPLACE, typeSuffix),
                items: ensureArray(items)
            };
        },
        /** Set meta content */
        setMeta: function (meta, typeSuffix) {
            return {
                type: makeType(constant.SET_META, typeSuffix),
                meta: meta
            };
        },
        /** Reset branch to initial state */
        reset: function (typeSuffix) { return ({
            type: makeType(constant.RESET, typeSuffix)
        }); },
        /** Do nothing */
        noop: function (typeSuffix) { return ({
            type: makeType(constant.NOOP, typeSuffix)
        }); }
    };
};
/** A factory for creating branches of your state. */
exports.stateBranch = function () { return function (_a) {
    var name = _a.name, _b = _a.defaultItem, defaultItem = _b === void 0 ? {} : _b, _c = _a.generateId, customGenerateIdFunc = _c === void 0 ? defaultGenerateId : _c, _d = _a.actions, customActions = _d === void 0 ? {} : _d, _e = _a.selectors, customSelectors = _e === void 0 ? {} : _e, _f = _a.constants, customConstants = _f === void 0 ? {} : _f, _g = _a.utils, utils = _g === void 0 ? {} : _g, _h = _a.defaultState, defaultState = _h === void 0 ? { items: {} } : _h, _j = _a.reducer, extendedReducer = _j === void 0 ? function (state, action) { return state; } : _j, rest = __rest(_a, ["name", "defaultItem", "generateId", "actions", "selectors", "constants", "utils", "defaultState", "reducer"]);
    var constant = __assign(__assign({}, customConstants), exports.createConstants(name));
    var defaultActions = exports.createActions({
        name: name,
        defaultItem: defaultItem,
        generateId: customGenerateIdFunc
    });
    var defaultSelectors = exports.createSelectors({
        name: name
    });
    var reducer = function (_state, _action) {
        if (_state === void 0) { _state = defaultState; }
        var state = _state;
        var action = _action;
        var items = ensureArray(action.items);
        var type = action.type.split('/', 2).join('/');
        switch (type) {
            case constant.CREATE:
                var newCreateItems = items.reduce(function (acc, item) {
                    acc[item.id] = __assign(__assign({}, (state.items[item.id] || {})), item);
                    return acc;
                }, {});
                return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), newCreateItems) });
            case constant.UPDATE:
                var newUpdateItems = items.reduce(function (acc, item) {
                    acc[item.id] = __assign(__assign({}, (state.items[item.id] || {})), item);
                    return acc;
                }, {});
                return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), newUpdateItems) });
            case constant.REPLACE:
                var newReplaceItems = items.reduce(function (acc, item) {
                    acc[item.id] = item;
                    return acc;
                }, {});
                return __assign(__assign({}, state), { items: __assign(__assign({}, state.items), newReplaceItems) });
            case constant.REMOVE:
                var newRemoveItems = items.reduce(function (acc, item) {
                    delete acc[item.id];
                    return acc;
                }, __assign({}, state.items));
                return __assign(__assign({}, state), { items: newRemoveItems });
            case constant.SET_META:
                return __assign(__assign({}, state), action.meta);
            case constant.RESET:
            case RESET_ALL:
                return defaultState;
            default:
                return extendedReducer(state, action);
        }
    };
    return __assign(__assign({}, rest), { name: name,
        constant: constant, util: utils, defaultItem: defaultItem,
        reducer: reducer,
        defaultState: defaultState, action: __assign(__assign({}, defaultActions), customActions), select: __assign(__assign({}, defaultSelectors), customSelectors) });
}; };
/** A factory for creating a Redux store. */
exports.createStore = function (_a) {
    var _b = _a.reducers, reducers = _b === void 0 ? {} : _b, _c = _a.middleware, middleware = _c === void 0 ? [] : _c, _d = _a.enhancers, enhancers = _d === void 0 ? [] : _d, _e = _a.devTools, devTools = _e === void 0 ? false : _e;
    // Easiest way to get devtools working in your browser if you have the extension installed
    var composeEnhancers = (devTools && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
        redux_1.compose;
    var rootReducer = redux_1.combineReducers(reducers);
    var enhancer = composeEnhancers.apply(void 0, __spreadArrays([redux_1.applyMiddleware.apply(void 0, middleware)], enhancers));
    return redux_1.createStore(rootReducer, enhancer);
};
//# sourceMappingURL=index.js.map